import React from 'react';

export default function Hero() {
  return (
    <div className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://static.readdy.ai/image/7952c1edd780462186458d18cb4f26e0/b22445331b322c0ce56661735a595278.jpeg"
          alt="Las Cruces Desert Landscape"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center py-20">
        <div className="mb-4 inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full border border-white/20">
          <i className="ri-translate-2 w-5 h-5 flex items-center justify-center text-white"></i>
          <span className="text-white text-sm font-medium">Se Habla Español</span>
        </div>

        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-white mb-4 leading-tight">
          Las Cruces Injury
          <br />
          <span className="text-[#F4A460] text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl">We're here for you!</span>
        </h1>

        <p className="text-sm sm:text-base md:text-lg lg:text-xl text-white/95 mb-6 max-w-3xl mx-auto leading-relaxed px-2">
          Experienced local medical and legal networks for <span className="underline font-bold text-white">auto accidents</span> and <span className="underline font-bold text-white">workplace injuries</span>.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-center mb-8 max-w-2xl mx-auto">
          <a
            href="#contact"
            className="bg-green-600 text-white px-6 py-3 sm:px-8 sm:py-4 rounded-full text-sm sm:text-base md:text-lg font-semibold hover:bg-green-700 transition-all transform hover:scale-105 shadow-xl cursor-pointer whitespace-nowrap w-full sm:w-auto text-center"
          >
            Get Your Free Consultation
            <span className="block text-xs sm:text-sm font-normal mt-1">Consulta Gratis</span>
          </a>

          <a
            href="tel:575-567-7668"
            className="bg-white/10 backdrop-blur-sm text-white border-2 border-white/30 px-6 py-3 sm:px-8 sm:py-4 rounded-full text-sm sm:text-base md:text-lg font-semibold hover:bg-white/20 transition-all cursor-pointer w-full sm:w-auto text-center flex items-center justify-center gap-2"
          >
            <i className="ri-phone-line text-lg"></i>
            <span>Call Now: 575-567-7668</span>
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-2xl mx-auto">
          <div className="bg-white/10 backdrop-blur-sm p-4 rounded-lg border border-white/20">
            <div className="w-10 h-10 flex items-center justify-center bg-[#D2691E] rounded-full mx-auto mb-3">
              <i className="ri-shield-check-line text-xl text-white"></i>
            </div>
            <h3 className="text-white font-semibold text-base mb-1">No Win, No Fee</h3>
            <p className="text-white/80 text-sm">You don't pay unless your case is won</p>
          </div>

          <div className="bg-white/10 backdrop-blur-sm p-4 rounded-lg border border-white/20">
            <div className="w-10 h-10 flex items-center justify-center bg-[#D2691E] rounded-full mx-auto mb-3">
              <i className="ri-time-line text-xl text-white"></i>
            </div>
            <h3 className="text-white font-semibold text-base mb-1">24/7 Availability</h3>
            <p className="text-white/80 text-sm">We're here when you need us most</p>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-3xl text-white/70"></i>
      </div>
    </div>
  );
}
